import api from './api';
import { User, UserRole } from '../types';

export interface UserWithStats extends User {
  _count?: {
    createdTasks: number;
    assignedTasks: number;
    createdIssues: number;
    assignedIssues: number;
    ownedProjects: number;
  };
  manager?: {
    id: string;
    name: string;
    email: string;
  };
  directReports?: Array<{
    id: string;
    name: string;
    email: string;
  }>;
}

export const getUsers = async (): Promise<UserWithStats[]> => {
  const response = await api.get('/api/users');
  return response.data.data;
};

export const getUserById = async (userId: string): Promise<UserWithStats> => {
  const response = await api.get(`/api/users/${userId}`);
  return response.data.data;
};

export const updateUser = async (
  userId: string,
  data: {
    name?: string;
    email?: string;
    role?: UserRole;
    department?: string;
    managerId?: string | null;
  }
): Promise<User> => {
  const response = await api.put(`/api/users/${userId}`, data);
  return response.data.data;
};

export const deleteUser = async (userId: string): Promise<void> => {
  await api.delete(`/api/users/${userId}`);
};

export const getUsersByRole = async (role: UserRole): Promise<User[]> => {
  const response = await api.get(`/api/users/role/${role}`);
  return response.data.data;
};

// Workspace sync
export interface WorkspaceSyncResult {
  total: number;
  created: number;
  updated: number;
  removed: number;
  skipped: number;
  errors: string[];
}

export const syncWorkspaceUsers = async (): Promise<WorkspaceSyncResult> => {
  const response = await api.post('/api/workspace/sync-users', undefined, {
    timeout: 120000,
  });
  return response.data.data;
};
